import objUtils from '../utils/objUtils';
import mainAPI from '../api/MainAPI';
import toasts from '../utils/toasts';
import scanViewController from './scanViewController';
import  {boxTransferPageRoute} from "../components/pages/boxTransferPage/BoxTransferPage";

let TransferDrugController = function () {
	this.drugs = [];
	this.transferAgency = false;
	this.start = (drugs, transferAgency) => {
		window.popupController.hideAll();
		this.transferAgency = transferAgency;
		this.drugs = drugs || [];
		scanViewController.setDrugs(drugs, 'Transfer');
		this.showScanner();
	};

	this.showScanner = () => {
		scanViewController.showScanner(
			'Scan a Drug',
			'Place the scan area on the code',
			this._handleScan,
			this._transferDrugs
		);
	};
	this._handleScan = async (text, inputManually, type, rawResults) => {
		for (let i in rawResults){
			const isLastResult = ((rawResults.length - 1) === parseInt(i))
			await this._processScan(rawResults[i].text, isLastResult);
		}
	};
	this._processScan = async (text, isLastResult= true) => {
		let drug = await mainAPI.drug.find_by_barcode({ barcode_id: text });

		if (!drug) {
			if(isLastResult) setTimeout(this.showScanner, 1000);
			return toasts.error('No drug found with that code');
		}
		if (drug.stock_move_record__quantity <= 0) {
			toasts.error(`${text} has already been used`);
		}
		if (this.transferAgency) {
			const info = await mainAPI.stock_move_record.userGroupTransferInfo(drug.id);
			if (info.drug_in_other_agency) {
				if (isLastResult) setTimeout(this.showScanner, 1000);
				return toasts.error('Drug is in another agency. Someone from that agency can transfer it back.');
			}
		}
		this._onAddAnother(drug, isLastResult);
	};
	this._onAddAnother = (drug, isLastResult = true) => {
		this.drugs.push(drug);
		let drugs = objUtils.to_obj(this.drugs, 'barcode_id');
		this.drugs = objUtils.to_array(drugs);
		scanViewController.setDrugs(this.drugs, 'Transfer');
		if(isLastResult) this.showScanner();
	};

	this._transferDrugs = () => {
		let drugIds = [];
		for (let i in this.drugs) {
			drugIds.push(this.drugs[i].id);
		}
		// window.popupController.hideAll();
		window.f7.views.current.router.navigate(boxTransferPageRoute, {
			props:{
			transferAgency: this.transferAgency,
			drugIds: JSON.stringify(drugIds)
		}});
		scanViewController.hideScanner();
	};
};

let transferDrugController = new TransferDrugController();

export default transferDrugController;
